// src/App.js
import React, { useEffect, useState, useMemo } from "react";
import FrontPage from "./FrontPage";
import Dashboard from "./DashboardIsolated";
import LegalPage from "./LegalPage";
import ServiceProvidersPage from "./features/service-providers/ServiceProvidersPage";
import IconPreview from "./components/IconPreview";
import R2Probe from "./components/R2Probe.jsx";
import WinnersPage from "./WinnersPage";
import { SignedIn, SignedOut, SignIn, SignUp, UserButton, useUser } from "@clerk/clerk-react";
function Placeholder({ title }) {
  return (
    <div style={{ padding: 24 }}>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginBottom: 12,
          padding: "8px 12px",
          borderRadius: 8,
          border: "1px solid #d0d6e0",
          background: "#fff",
          cursor: "pointer",
        }}
      >
        ← Back
      </button>
      <h2 style={{ margin: 0 }}>{title}</h2>
      <p style={{ color: "#546072" }}>This service will be implemented next.</p>
    </div>
  );
}

export default function App() {
  console.log("🚀 APP COMPONENT LOADED - CHECKING VIEW STATE 🚀");
  const [view, setView] = useState(() => {
    // Initialize view from URL (?view=...) so auth redirects can land directly in the dashboard
    try {
      const qp = new URLSearchParams(window.location.search);
      return qp.get("view") || "home";
    } catch {
      return "home";
    }
  });
  const [authModal, setAuthModal] = useState(null); // 'login' or 'signup' or null
  const { isSignedIn, user } = useUser();
  
  // Memoize URLSearchParams to prevent re-creating on every render
  const preview = useMemo(() => {
  const qp = new URLSearchParams(window.location.search);
    return qp.get("preview");
  }, []);

  const open = (key) => {
    // Legal page must be accessible without sign-in
    if (key === "legal") {
      setView("legal");
      return;
    }
    // Gate feature views: require sign-in before opening
    // if (!isSignedIn) {
    //   setAuthModal("login");
    //   return;
    // }
    if (key === "dashboard") setView("dashboard");
    else setView(key);
  };

  useEffect(() => {
    if (isSignedIn) {
      // Close modal and send newly authenticated users through the winners view first
      setAuthModal(null);
      setView("winners");
    }
  }, [isSignedIn]);

  if (preview === "icons") {
    return <IconPreview onBack={() => { 
      const qp = new URLSearchParams(window.location.search);
      qp.delete("preview"); 
      window.location.search = qp.toString(); 
    }} />;
  }
  if (preview === "r2") {
    return <R2Probe onBack={() => { 
      const qp = new URLSearchParams(window.location.search);
      qp.delete("preview"); 
      window.location.search = qp.toString(); 
    }} />;
  }

  if (view === "dashboard") {
    console.log("🚀 RENDERING ISOLATED DASHBOARD COMPONENT 🚀");
    // if (!isSignedIn) {
    //   return (
    //     <div style={{ maxWidth: 520, margin: '40px auto' }}>
    //       <button onClick={() => setView('home')} style={{ marginBottom: 12 }}>← Back</button>
    //       <SignIn 
    //         fallbackRedirectUrl="/?view=winners" 
    //       />
    //     </div>
    //   );
    // }
    return (
      <div>
        <div style={{ borderBottom: '1px solid #e5e7eb' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', marginLeft: 'max(12px, calc((100vw - 1100px) / 4))', marginRight: 'max(12px, calc((100vw - 1100px) * 3 / 4))' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <button 
                onClick={() => setView('winners')}
                style={{
                  padding: '6px 12px',
                  background: '#ffffff',
                  border: '1px solid #d0d6e0',
                  borderRadius: '6px',
                  color: '#334155',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#f8fafc';
                  e.currentTarget.style.borderColor = '#94a3b8';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#ffffff';
                  e.currentTarget.style.borderColor = '#d0d6e0';
                }}
              >
                ← Back
              </button>
              {user?.publicMetadata?.isAdmin ? (
                <button onClick={() => setView('home')}>Admin</button>
              ) : null}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <SignedIn>
                <span>Hi, {user?.firstName || user?.primaryEmailAddress?.emailAddress}</span>
                <UserButton />
              </SignedIn>
              <SignedOut>
                <button onClick={() => setView('login')}>Sign in</button>
              </SignedOut>
            </div>
          </div>
        </div>
        <Dashboard />
      </div>
    );
  }

  if (view === "winners") {
    // if (!isSignedIn) {
    //   return (
    //     <div style={{ maxWidth: 520, margin: '40px auto' }}>
    //       <button onClick={() => setView('home')} style={{ marginBottom: 12 }}>← Back</button>
    //       <SignIn 
    //         fallbackRedirectUrl="/?view=winners" 
    //       />
    //     </div>
    //   );
    // }
    return (
      <WinnersPage  
        onBack={() => setView("home")}
        onContinue={() => setView("dashboard")}
      />
    );
  }

  if (view === "legal") {
    return <LegalPage onBack={() => setView("home")} />;
  }

  // Auth modal is now handled as overlay on home page, not separate views

  // Admin management UI will be reimplemented with Clerk Admin API in a later step.

  // Temporary placeholders for the other tiles
  const titles = {
    serviceProviders: "Service Providers",
    photosImprovements: "Photos Improvements",
    virtualStaging: "Virtual Staging",
    virtualRenovations: "Virtual Renovations",
    autoHomeDesign: "Automatic Home Design",
    projectCost: "Project Cost estimation",
  };
if (view === "serviceProviders") {
  return <ServiceProvidersPage onBack={() => setView("home")} />;
}
  if (view !== "home" && titles[view]) return <Placeholder title={titles[view]} />;

  return (
    <div>
      <FrontPage 
        onOpen={open} 
        onShowAuth={() => setAuthModal("login")}
        onShowSignup={() => setAuthModal("signup")}
        isSignedIn={isSignedIn}
        user={user}
      />
      
      {/* Auth Modal Overlay */}
      {authModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(4px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '20px'
          }}
          onClick={() => setAuthModal(null)}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 12,
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
              maxWidth: 520,
              width: '100%',
              maxHeight: '90vh',
              overflow: 'auto',
              position: 'relative'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={() => setAuthModal(null)}
              style={{
                position: 'absolute',
                top: 16,
                right: 16,
                background: 'transparent',
                border: 'none',
                fontSize: 24,
                cursor: 'pointer',
                color: '#6b7280',
                padding: '4px 8px',
                lineHeight: 1,
                zIndex: 10
              }}
              aria-label="Close"
            >
              ×
            </button>
            
            <div style={{ padding: '24px' }}>
              {authModal === "login" ? (
                <>
          <SignIn 
            fallbackRedirectUrl="/?view=winners"
            routing="hash"
                    appearance={{
                      elements: {
                        rootBox: "clerk-root-box",
                        card: "clerk-card"
                      },
                      layout: {
                        socialButtonsPlacement: "top",
                        socialButtonsVariant: "blockButton",
                        logoPlacement: "none"
                      }
                    }}
                  />
                  <div style={{ marginTop: 16, textAlign: 'center', fontSize: 14 }}>
                    Don't have an account?{' '}
                    <button 
                      onClick={() => setAuthModal("signup")}
                      style={{ 
                        background: 'none', 
                        border: 'none', 
                        color: '#2563eb', 
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        padding: 0,
                        font: 'inherit'
                      }}
                    >
                      Sign up
                    </button>
                  </div>
                </>
              ) : (
                <>
          <SignUp 
            termsOfServiceUrl="https://algoreitai.tech/?view=legal"
            privacyPolicyUrl="https://algoreitai.tech/?view=legal"
            fallbackRedirectUrl="/?view=winners"
            routing="hash"
                    appearance={{
                      elements: {
                        rootBox: "clerk-root-box",
                        card: "clerk-card"
                      },
                      layout: {
                        socialButtonsPlacement: "top",
                        socialButtonsVariant: "blockButton",
                        logoPlacement: "none"
                      }
                    }}
                  />
                  <div style={{ marginTop: 16, textAlign: 'center', fontSize: 14 }}>
                    Already have an account?{' '}
                    <button 
                      onClick={() => setAuthModal("login")}
                      style={{ 
                        background: 'none', 
                        border: 'none', 
                        color: '#2563eb', 
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        padding: 0,
                        font: 'inherit'
                      }}
                    >
                      Log in
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
